/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-info',['require','jquery','activities/scenario-activity'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  //var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityInfo = ScenarioActivity.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    attempt: 0,
    maxAttempts: 2,
    scoreValue: 4,

    handPanel: null,
    slider: null,
    doneBtn: null,

    directionsPanel: null,
    tiltObject: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ScenarioActivity.prototype.initialize.apply(this, arguments);

      this.performance = 'good';

      this.attempt = 0;
      this.maxAttempts = 2;
      this.scoreValue = 4;

      //this.activityReady();
    },

    begin: function()
    {
      ScenarioActivity.prototype.begin.apply(this, arguments);
      //var self = this;
      //console.warn('show', this.get('#animation-sprite img'));

      //this.playAudio();
      this.playAudio('audio', this.content, this.setupActivity);
      /*//console.log(this.get('#animation-sprite'));
      this.get('#animation-sprite').sprite({
        'fps': 1,
        'no_of_frames': 2,
        'play_frames': 4,
        //'on_last_frame': self.finish.bind(self)
      });
      //console.log('showing now it should play');
      setTimeout(function() {self.get('#animation-sprite').spStart(true);}, 1000);*/
    },

    onBeforeDestroy: function()
    {

      ScenarioActivity.prototype.onBeforeDestroy.apply(this);
    },

    finish: function()
    {
      this.performance = 'good';

      this.doneBtn.off('click');
      this.doneBtn.addClass('disabled');

      ScenarioActivity.prototype.finish.apply(this);
    },

    setupActivity: function()
    {
      this.playAudio('audio', this.currentPhase);

      //console.log('SETUP INFO');

      this.doneBtn = this.get('[data-id=close-activity]');
      this.doneBtn.one('click', $.proxy(this.onDoneClick, this));
      //this.handPanel.setup( { onDragStop: this.onCorrectDrop } );
    },

    onDoneClick: function($e)
    {
      // check correctness
      this.finish();
    }

  /*****************************************************************************************************************///}

  });

  return ActivityInfo;

});

